module.exports = __webpack_public_path__ + "images/emoji/loop.82c05123406c0f4a1787.png";